import React from 'react'

import { type StarChartsOrgActionContainerProps } from '../../types/types'
import StarChartsOrgActionPresentation from '../../presentation/starChartOrg.action.presentation/StarChartsOrgActionPresentation'

const StarChartsOrgActionContainer: React.FC<StarChartsOrgActionContainerProps> = ({
  openStarChartsAddHandler,
  term,
  setTerm,
  clonePopup,
  onClonePopup
}) => {
  return (
    <StarChartsOrgActionPresentation
      openStarChartsAddHandler={openStarChartsAddHandler}
      term={term}
      setTerm={setTerm}
      clonePopup={clonePopup}
      onClonePopup={onClonePopup}
    />
  )
}

export default StarChartsOrgActionContainer
